import { useLocalStorage } from '@vueuse/core'
import { computed } from 'vue'
import { usePlayer } from '@/composables/game/player'
import { SettingsNotificationType } from '@/types/shared/settings'
import api from '@/services/api'

type Settings = {
  hapticFeedback: boolean
  coinAnimation: boolean
}

type NotificationSettings = {
  energyRefilled: boolean,
  offlineProfit: boolean,
  referral: boolean,
  poked: boolean
}

export const useNotificationSettings = () => {
  const { player, updatePlayer } = usePlayer()
  const notificationSettings = computed<NotificationSettings>(() => {
    return {
      energyRefilled: player.value.settings.notifications.energyRefilled,
      offlineProfit: player.value.settings.notifications.offlineProfit,
      referral: player.value.settings.notifications.referral,
      poked: player.value.settings.notifications.poke,
    }
  },
  )

  async function updateNotificationState(notificationType: SettingsNotificationType, value: boolean) {
    const result = await api.updateNotificationSettings(notificationType, value)
    if (result.playerStats) {
      updatePlayer(result.playerStats)
    } else {
      console.error('Notification setting error', notificationType)
    }
  }

  return {
    notificationSettings,
    updateNotificationState,
  }
}

export const useDeviceSettings = () => {

  // We don't use buildDropeeStorageKey since this value should never be reset on the device
  const settings = useLocalStorage<Settings>('localGameSettings', {
    hapticFeedback: true,
    coinAnimation: true,
  })

  return {
    gameDeviceSettings: computed(() => settings.value),
    setHapticFeedback: (value: boolean) => {
      settings.value.hapticFeedback = value
    },
    setCoinAnimation: (value: boolean) => {
      settings.value.coinAnimation = value
    },
  }
}
